import { LabelEnum } from 'app/shared/enums';
import isIdCardNumberValid from '../validateIdCardNumber';

const idCardNumber = (value: string) => {
  return isIdCardNumberValid(value) ? undefined : LabelEnum.InvalidIdCardNumber;
};

export default idCardNumber;
